import { FeatureConfiguration } from "..";
import { hostedFieldsReducer } from "./reducers";

export * from "./reducers";

export default function (config: FeatureConfiguration) {
    config.reducers.hostedFields = hostedFieldsReducer;
}
